define('modules/editor/views/property_boxes/page_notification',['require','exports','module','./base','ldsh!../../templates/property_boxes/page_notification_amp'],function(require, exports, module){
  "use strict";
  var BasePropertyBox = require("./base");
  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/page_notification_amp"),
    i18n: {
      "message": "editor.page.notificationDefaultMessage",
      "linkText": "editor.page.notificationDefaultLinkText",
      "title": "editor.page.notificationDefaultTitle"
    },
    onBeforeRender: function(){
      if(!this.model.get("message")){
        this.model.set("message", this.i18n.message, {silent:true});
      }
      if(!this.model.has("title")){
        this.model.set("title", this.i18n.title, {silent:true});
      }
      if(!this.model.get("linkText")){
        this.model.set("linkText", this.i18n.linkText, {silent:true});
      }
    }
  });
});

